import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../api/auth.api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      setMessage("Please fill in all fields ❌");
      return;
    }
    setLoading(true);
    try {
      const data = await loginUser(email, password);
      if (data.success) {
        login(data.token, data.role);
        if (data.role === "admin") {
          navigate("/admin/hiring");
        } else {
          navigate("/user-profile");
        }
      } else {
        setMessage(data.error || "Login failed ❌");
      }
    } catch (err) {
      setMessage("Server error ❌");
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#fafafa",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
      padding: "20px",
    }}>
      <style>{`
        .login-input:focus {
          outline: none;
          border-color: #1a1a1a !important;
          box-shadow: 0 0 0 3px rgba(26,26,26,0.08);
        }
        .login-btn {
          transition: all 0.2s ease;
        }
        .login-btn:hover {
          opacity: 0.88;
          transform: translateY(-1px);
        }
        .login-btn:active {
          transform: translateY(0px);
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .fade-up {
          animation: fadeUp 0.4s ease forwards;
        }
      `}</style>

      <div className="fade-up" style={{
        width: "100%",
        maxWidth: "420px",
      }}>

        {/* LOGO / BRAND */}
        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <div style={{
            width: "52px", height: "52px",
            background: "linear-gradient(135deg, #1a1a2e 0%, #7b19bc 100%)",
            borderRadius: "14px",
            margin: "0 auto 16px",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <h1 style={{ margin: "0 0 6px", fontSize: "24px", fontWeight: 700, color: "#7b19bc", letterSpacing: "-0.5px" }}>
            Welcome back
          </h1>
          <p style={{ margin: 0, fontSize: "14px", color: "#888" }}>
            Sign in to your account
          </p>
        </div>

        {/* CARD */}
        <div style={{
          background: "#fff",
          borderRadius: "20px",
          border: "1px solid #e8e8e8",
          padding: "36px 32px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
        }}>

          {/* EMAIL */}
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#666", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              Email
            </label>
            <input
              className="login-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: "10px",
                border: "1.5px solid #e0e0e0",
                fontSize: "14px",
                boxSizing: "border-box",
                fontFamily: "inherit",
                color: "#1a1a1a",
                transition: "border-color 0.2s",
                background: "#fafafa",
              }}
            />
          </div>

          {/* PASSWORD */}
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#666", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              Password
            </label>
            <input
              className="login-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: "10px",
                border: "1.5px solid #e0e0e0",
                fontSize: "14px",
                boxSizing: "border-box",
                fontFamily: "inherit",
                color: "#1a1a1a",
                transition: "border-color 0.2s",
                background: "#fafafa",
              }}
            />
          </div>

          {/* ERROR MESSAGE */}
          {message && (
            <div style={{
              background: "#fff0f0",
              border: "1px solid #ffd0d0",
              borderRadius: "8px",
              padding: "10px 14px",
              marginBottom: "16px",
              fontSize: "13px",
              color: "#cc0000",
            }}>
              {message}
            </div>
          )}

          {/* LOGIN BUTTON */}
          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: "100%",
              padding: "13px",
              background: "#1a1a1a",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "inherit",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>

        {/* FOOTER LINKS */}
        <p style={{ textAlign: "center", marginTop: "20px", fontSize: "14px", color: "#888" }}>
          Don't have an account?{" "}
          <a href="/signup" style={{ color: "#1a1a1a", fontWeight: 600, textDecoration: "none" }}>
            Sign Up
          </a>
        </p>

      </div>
    </div>
  );
}